import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, signal } from "@angular/core";
import { JwtToken } from "@core/models/jwt-token";

@Injectable({
  providedIn: "root",
})
export class GlobalService {
  offline = signal<boolean>(false);
  isApaApp = signal<boolean>(false);
  isApaAppV3 = signal<boolean>(false);
  authedToken = signal<JwtToken>({} as JwtToken);
  isAdmin = signal<boolean>(false);
  isSupport = signal<boolean>(false);
  theme = signal<string>("light");
  fontSize = signal<string>("medium");
  device = signal<string>("desktop");
  screenWidth = signal<number>(0);
  navbarHeight = signal<number>(52);
  emulatedUser = signal<string>("");

  private readonly _themes = [
    {
      id: "mdc-light-indigo",
      label: "MDC Light Indigo",
    },
    {
      id: "mdc-dark-indigo",
      label: "MDC Dark Indigo",
    },
  ];

  constructor(@Inject(DOCUMENT) private document: Document) {}

  applyTheme(appliedTheme: string): void {
    const themeId =
      appliedTheme === "light" ? "mdc-light-indigo" : "mdc-dark-indigo";
    let themeLink = this.document.getElementById(
      "app-theme",
    ) as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = themeId + ".css";
    }
    localStorage.setItem("theme", appliedTheme);
    this.theme.set(appliedTheme);
  }
}
